import { render } from "./SignUpForm.vue?vue&type=template&id=560c4087&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=560c4087&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560c4087"]])

export default __exports__